/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Integration } from '../models/Integration';
import type { IntegrationCreateRequest } from '../models/IntegrationCreateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class IntegrationService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * List Integration
   * @param slug
   * @returns Integration Successful Response
   * @throws ApiError
   */
  public listIntegrationV1WorkspaceSlugIntegrationsGet(
    slug: string
  ): CancelablePromise<Array<Integration>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/integrations',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Integration
   * @param slug
   * @param requestBody
   * @returns Integration Successful Response
   * @throws ApiError
   */
  public createIntegrationV1WorkspaceSlugIntegrationsPost(
    slug: string,
    requestBody: IntegrationCreateRequest
  ): CancelablePromise<Integration> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/integrations',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        409: `Conflict`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * @deprecated
   * List Integration
   * @param slug
   * @returns Integration Successful Response
   * @throws ApiError
   */
  public listIntegrationV1WorkspaceSlugIntegrationGet(
    slug: string
  ): CancelablePromise<Array<Integration>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/integration',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * @deprecated
   * Create Integration
   * @param slug
   * @param requestBody
   * @returns Integration Successful Response
   * @throws ApiError
   */
  public createIntegrationV1WorkspaceSlugIntegrationPost(
    slug: string,
    requestBody: IntegrationCreateRequest
  ): CancelablePromise<Integration> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/integration',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        409: `Conflict`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Delete Integration
   * @param id
   * @param slug
   * @returns void
   * @throws ApiError
   */
  public deleteIntegrationV1WorkspaceSlugIntegrationsIdDelete(
    id: number,
    slug: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/workspace/{slug}/integrations/{id}',
      path: {
        id: id,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * @deprecated
   * Delete Integration
   * @param id
   * @param slug
   * @returns void
   * @throws ApiError
   */
  public deleteIntegrationV1WorkspaceSlugIntegrationIdDelete(
    id: number,
    slug: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/workspace/{slug}/integration/{id}',
      path: {
        id: id,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
